import { render, staticRenderFns } from "./GastosList.vue?vue&type=template&id=85a6c500&scoped=true&"
import script from "./GastosList.vue?vue&type=script&lang=js&"
export * from "./GastosList.vue?vue&type=script&lang=js&"
import style0 from "./GastosList.vue?vue&type=style&index=0&id=85a6c500&prod&lang=scss&scoped=true&"
import style1 from "./GastosList.vue?vue&type=style&index=1&id=85a6c500&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a6c500",
  null
  
)

export default component.exports